var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmenitiesIconcomponent = function SvgAmenitiesIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.617 7.223A8.844 8.844 0 0 0 9.046 1.5a9.14 9.14 0 0 0-2.662 5.723A10.4 10.4 0 0 1 9 9.194a10.768 10.768 0 0 1 2.617-1.973ZM6.7 9.18a1.925 1.925 0 0 1 .006.004L6.7 9.18Zm0 0A8.858 8.858 0 0 0 1.5 7.5c0 3.99 2.52 7.365 6.022 8.617.473.173.968.3 1.478.383.51-.09.998-.218 1.477-.383C13.98 14.865 16.5 11.49 16.5 7.5c-3.135 0-5.887 1.627-7.5 4.088a9.153 9.153 0 0 0-2.294-2.403c-.039-.026-.079-.05-.12-.075a2.443 2.443 0 0 1-.181-.117c.047.031.096.061.144.091.051.032.102.064.151.097Z",
    fill: "#CECCC9"
  })));
};
export default SvgAmenitiesIconcomponent;